import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingScreen = ({ message = 'Loading...', cover = true }) => {
  return (
    <Box
      sx={{
        position: cover ? 'fixed' : 'relative',
        inset: cover ? 0 : 'auto',
        width: '100%',
        minHeight: cover ? '100dvh' : '100vh',
        display: 'grid',
        placeItems: 'center',
        backgroundColor: 'background.default',
        zIndex: (theme) => (cover ? (theme.zIndex.appBar - 1) : 'auto')
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.25 }}>
        <CircularProgress size={24} thickness={5} />
        <Typography variant="body2" color="text.secondary">
          {message || 'Loading...'}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingScreen;
